/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InviteDto } from '../../models/invite-dto';

export interface ApiInvitesSpaceSpaceIdGet$Params {
  spaceId: string;
}

export function apiInvitesSpaceSpaceIdGet(http: HttpClient, rootUrl: string, params: ApiInvitesSpaceSpaceIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<InviteDto>>> {
  const rb = new RequestBuilder(rootUrl, apiInvitesSpaceSpaceIdGet.PATH, 'get');
  if (params) {
    rb.path('spaceId', params.spaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<InviteDto>>;
    })
  );
}

apiInvitesSpaceSpaceIdGet.PATH = '/api/Invites/space/{spaceId}';
